// Captura de errores no controlados

function errorGeneral() {
    // Mostramos el cuadro "error-general" que estaba oculto
    // eslint-disable-next-line no-undef
    document.getElementById('error-general').style.display = 'block';
    // Ocultamos todos los indicadores de espera para que no parezca
    // que seguimos haciendo algo
    // eslint-disable-next-line no-undef
    var ruedas = document.getElementsByClassName('spinner');
    for (var i=0; i<ruedas.length; i++) {
      ruedas.item(i).style.display = 'none';
    }
  }

function quitarErrorGeneral() {
    // Ocultar el cuadro "error-general" cuando no se necesita
    // eslint-disable-next-line no-undef
    document.getElementById('error-general').style.display = 'none';
}

export {errorGeneral, quitarErrorGeneral}
